/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.intervention.administration'},
});

const AdministrationItem = () => (
  <RouteLinkItem
    route="midas/settings/intervention/administration"
    title={messages.title}
  />
);

export default AdministrationItem;
